import React from 'react'

function Loader() {
  return (
    <div
      className="Modal Loading"
      role="dialog"
      aria-labelledby="modalTitle"
      aria-describedby="modalDesc"
    >
      <section className="Modal-window u-decoShadowReset u-bgColorTransparent">
        <div className="Modal-content Content u-textCenter" id="modalDesc">
          <div className="Loading-icon"></div>
        </div>
      </section>
    </div>
  )
}

export default Loader
